import React from 'react';
import Copyright from '../../components/copyright';
import Article from '../../components/article';
import NewsApi from '../../data/mockNewsApi';

const articleList = NewsApi.getAllNews()

articleList.splice(0,1);

let articles = articleList.map(article => 
  <span>
    <Article title={article.linkTitle} content={article.shortContent} date={article.date} />
    <br/>
  </span>
);

export default () => (
  <div>
    <h1>News</h1>
    {articles}
    <Copyright copyholder='Ol&#039; Dawg.com' />
  </div>
)